/* Thème sur mesure – scripts (sans dépendance) */
(function () {
  'use strict';

  var T = window.theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Utilitaires ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}} €';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(n, dec, th, sep) {
      dec = isNaN(dec) ? 2 : dec;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (th || ','));
      var c = parts[1] ? (sep || '.') + parts[1] : '';
      return d + c;
    }
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Tiroirs ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var f = $('button, a, input', d.querySelector('.drawer__panel'));
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    $$('[data-drawer].is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); openDrawer(open.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeSearch(); closePopup(); }
  });

  /* ---------- Panier ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
  }

  function refreshCart(open) {
    var onCartPage = !!$('[data-cart-page]');
    var sectionId = onCartPage ? null : 'cart-drawer';
    if (onCartPage) {
      return fetch(window.location.pathname + '?section_id=' + getMainCartSection())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-page]');
          var cur = $('[data-cart-page]');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          return fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); });
        });
    }
    return fetch(T.routes.root + '?section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        var cur = $('[data-cart-drawer]');
        if (fresh && cur) {
          var panel = cur.querySelector('.drawer__panel');
          var freshPanel = fresh.querySelector('.drawer__panel');
          if (panel && freshPanel) panel.innerHTML = freshPanel.innerHTML;
          var body = fresh.querySelector('[data-cart-body]');
          if (body) updateCount(parseInt(body.getAttribute('data-item-count'), 10) || 0);
        }
        if (open) openDrawer('cart-drawer');
      });
  }
  function getMainCartSection() {
    var s = $('[data-cart-page]');
    var wrap = s && s.closest('.shopify-section');
    return wrap ? wrap.id.replace('shopify-section-', '') : 'main-cart';
  }

  function addToCart(form, btn) {
    var fd = new FormData(form);
    // Quantité gérée hors du formulaire (bloc quantité ou offres par quantité)
    if (!fd.get('quantity')) {
      var q = document.querySelector('[form="' + form.id + '"][name="quantity"]');
      fd.set('quantity', q ? q.value : 1);
    }
    if (btn) btn.classList.add('is-loading');
    var err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || T.strings.error);
        if (T.cartType === 'page') { window.location.href = T.routes.cart; return; }
        return refreshCart(true);
      })
      .catch(function (e) {
        if (err) { err.textContent = e.message; err.hidden = false; } else { toast(e.message); }
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || form.tagName !== 'FORM') return;
    if (!window.fetch) return;
    e.preventDefault();
    addToCart(form, $('[data-add-btn]', form));
  });

  // Changement de quantité / suppression dans le panier
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var item = btn.closest('[data-line]');
    if (!item) return;
    item.classList.add('is-loading');
    fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(item.getAttribute('data-line'), 10), quantity: parseInt(btn.getAttribute('data-qty-change'), 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) toast(res.description);
        return refreshCart(false);
      })
      .catch(function () { toast(T.strings.error); item.classList.remove('is-loading'); });
  });

  // Ouvrir le panier latéral au clic sur l'icône
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-open]');
    if (!a || T.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
    if ($('[data-cart-page]')) return;
    e.preventDefault();
    openDrawer('cart-drawer');
  });

  /* ---------- En-tête : ombre au défilement ---------- */
  var header = $('[data-header]');
  var backTop = $('[data-back-to-top]');
  function onScroll() {
    var y = window.scrollY;
    if (header) header.classList.toggle('is-scrolled', y > 10);
    if (backTop) backTop.classList.toggle('is-visible', y > 700);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  if (backTop) backTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* ---------- Barre d'annonce rotative ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Recherche prédictive ---------- */
  var overlay = $('[data-search-overlay]');
  var sInput = $('[data-search-input]');
  var sResults = $('[data-search-results]');
  function closeSearch() { if (overlay) overlay.hidden = true; }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]') && overlay) {
      overlay.hidden = !overlay.hidden;
      if (!overlay.hidden && sInput) sInput.focus();
    } else if (e.target.closest('[data-search-close]')) {
      closeSearch();
    }
  });
  var sTimer;
  if (sInput && sResults) {
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (q.length < 2) { sResults.innerHTML = ''; return; }
      sTimer = setTimeout(function () {
        fetch(T.routes.search + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { sResults.innerHTML = '<p>' + T.strings.noResults + '</p>'; return; }
            var html = '<p class="search-results__title">' + T.strings.products + '</p>';
            products.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '';
              html += '<a class="search-results__item" href="' + p.url + '">' + img + '<div><strong>' + escapeHtml(p.title) + '</strong><span>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></div></a>';
            });
            html += '<a class="link-arrow" href="/search?type=product&q=' + encodeURIComponent(q) + '">' + T.strings.viewAll + ' →</a>';
            sResults.innerHTML = html;
          })
          .catch(function () { sResults.innerHTML = ''; });
      }, 250);
    });
  }
  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* ---------- Diaporama héro ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var slides = $$('.hero__slide', slider);
    var dots = $$('[data-slider-dot]', slider);
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
    }
    function play() {
      if (slider.getAttribute('data-autoplay') !== 'true') return;
      clearInterval(timer);
      timer = setInterval(function () { go(i + 1); }, (parseInt(slider.getAttribute('data-speed'), 10) || 6) * 1000);
    }
    var prev = $('[data-slider-prev]', slider), next = $('[data-slider-next]', slider);
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slider-dot'), 10)); play(); }); });
    // Glisser sur mobile
    var startX = null;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { go(dx < 0 ? i + 1 : i - 1); play(); }
      startX = null;
    });
    play();
  });

  /* ---------- Comptes à rebours (vraie date de fin) ---------- */
  function parseDate(str) {
    var m = String(str).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59), 59);
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  $$('[data-countdown]').forEach(function (el) {
    var end = parseDate(el.getAttribute('data-countdown'));
    if (!end) return;
    function tick() {
      var diff = Math.floor((end - new Date()) / 1000);
      if (diff <= 0) { el.hidden = true; clearInterval(t); return; }
      el.hidden = false;
      var d = Math.floor(diff / 86400), h = Math.floor(diff % 86400 / 3600), m = Math.floor(diff % 3600 / 60), s = diff % 60;
      var boxes = $('[data-countdown-boxes]', el);
      if (boxes) {
        $('[data-cd="d"]', el).textContent = pad(d);
        $('[data-cd="h"]', el).textContent = pad(h);
        $('[data-cd="m"]', el).textContent = pad(m);
        $('[data-cd="s"]', el).textContent = pad(s);
      }
      var v = $('[data-countdown-value]', el);
      if (v) v.textContent = (d > 0 ? d + T.strings.countdownDays + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    var t = setInterval(tick, 1000);
    tick();
  });

  /* ---------- Page produit ---------- */
  $$('[data-product-section]').forEach(initProduct);

  function initProduct(section) {
    var dataEl = $('[data-product-json]', section);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('form[data-product-form]', section);
    var idInput = $('[data-variant-id]', section);
    var addBtn = $('[data-main-add]', section);
    var current = product.variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || product.variants[0];

    // Galerie
    var main = $('[data-gallery-main]', section);
    var thumbs = $$('[data-thumb]', section);
    var dots = $$('[data-dot]', section);
    function showMedia(id, smooth) {
      if (!main || !id) return;
      var slide = $('[data-media-id="' + id + '"]', main);
      if (!slide) return;
      main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(id);
    }
    function setActive(id) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
      dots.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-dot') === String(id)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    if (main) {
      var sTo;
      main.addEventListener('scroll', function () {
        clearTimeout(sTo);
        sTo = setTimeout(function () {
          var idx = Math.round(main.scrollLeft / main.clientWidth);
          var slide = $$('.gallery__slide', main)[idx];
          if (slide) setActive(slide.getAttribute('data-media-id'));
        }, 80);
      }, { passive: true });
      var active = $('.gallery__slide.is-active', main);
      if (active && active !== main.firstElementChild) showMedia(active.getAttribute('data-media-id'), false);
    }

    // Quantité
    var qtyInput = $('[data-qty-input]', section);
    $$('[data-qty-minus]', section).forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); syncBreaks(); }); });
    $$('[data-qty-plus]', section).forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; syncBreaks(); }); });
    if (qtyInput) qtyInput.addEventListener('change', syncBreaks);

    function setQty(n) {
      if (qtyInput) { qtyInput.value = n; return; }
      if (!form) return;
      var h = $('input[name="quantity"]', form);
      if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'quantity'; form.appendChild(h); }
      h.value = n;
    }

    // Offres par quantité
    var breaks = $$('[data-qbreak]', section);
    function renderBreaks() {
      breaks.forEach(function (b) {
        var q = parseInt(b.getAttribute('data-qty'), 10) || 1;
        var disc = parseFloat(b.getAttribute('data-discount')) || 0;
        var full = current.price * q;
        var total = Math.round(full * (1 - disc / 100));
        var compareBase = current.compare_at_price > current.price ? current.compare_at_price * q : (disc > 0 ? full : 0);
        $('[data-qbreak-total]', b).textContent = formatMoney(total);
        var c = $('[data-qbreak-compare]', b);
        c.textContent = compareBase > total ? formatMoney(compareBase) : '';
      });
    }
    function syncBreaks() {
      if (!breaks.length || !qtyInput) return;
      var q = parseInt(qtyInput.value, 10);
      breaks.forEach(function (b) {
        var match = parseInt(b.getAttribute('data-qty'), 10) === q;
        b.classList.toggle('is-selected', match);
        $('input', b).checked = match;
      });
    }
    breaks.forEach(function (b) {
      $('input', b).addEventListener('change', function () {
        breaks.forEach(function (x) { x.classList.remove('is-selected'); });
        b.classList.add('is-selected');
        setQty(parseInt(b.getAttribute('data-qty'), 10) || 1);
      });
    });
    if (breaks.length) {
      var sel = breaks.filter(function (b) { return b.classList.contains('is-selected'); })[0];
      if (sel) setQty(parseInt(sel.getAttribute('data-qty'), 10) || 1);
    }

    // Variantes
    var picker = $('[data-variant-picker]', section);
    if (picker) {
      picker.addEventListener('change', function () {
        var opts = $$('fieldset', picker).map(function (fs) {
          var c = $('input:checked', fs);
          var lab = $('[data-option-selected]', fs);
          if (c && lab) lab.textContent = c.value;
          return c ? c.value : null;
        });
        var v = product.variants.find(function (x) {
          return x.options.every(function (o, i) { return o === opts[i]; });
        });
        updateVariant(v);
      });
    }

    function updateVariant(v) {
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = T.strings.unavailable; }
        return;
      }
      current = v;
      if (idInput) idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; }
      var sticky = $('[data-sticky-add]', section);
      if (sticky) { sticky.disabled = !v.available; }
      var sp = $('[data-sticky-price]', section);
      if (sp) sp.textContent = formatMoney(v.price);

      // Prix
      var priceWrap = $('[data-product-price]', section);
      if (priceWrap) {
        var cur = $('[data-price-current]', priceWrap);
        var cmp = $('[data-price-compare]', priceWrap);
        var badge = $('[data-price-badge]', priceWrap);
        var unit = $('[data-unit-price]', priceWrap);
        if (unit) unit.hidden = true; // le prix unitaire exact s'affiche au rechargement de la variante
        cur.textContent = formatMoney(v.price);
        var sale = v.compare_at_price > v.price;
        $('[data-price]', priceWrap).classList.toggle('price--sale', sale);
        if (cmp) { cmp.hidden = !sale; cmp.textContent = sale ? formatMoney(v.compare_at_price) : ''; }
        if (badge) {
          badge.hidden = !sale;
          if (sale) badge.textContent = (badge.getAttribute('data-template') || '-__AMOUNT__').replace('__AMOUNT__', formatMoney(v.compare_at_price - v.price));
        }
      }

      // Stock
      var stock = $('[data-stock]', section);
      if (stock) {
        var dot = $('.stock__dot', stock), txt = $('[data-stock-text]', stock);
        var th = parseInt(stock.getAttribute('data-threshold'), 10) || 10;
        dot.className = 'stock__dot';
        if (!v.available) { dot.classList.add('stock__dot--out'); txt.textContent = T.strings.soldOut; }
        else if (v.tracked && v.qty > 0 && v.qty <= th) { dot.classList.add('stock__dot--low'); txt.textContent = T.strings.stockLow.replace('__N__', v.qty); }
        else { txt.textContent = T.strings.inStock; }
      }

      if (v.featured_media) showMedia(v.featured_media);
      renderBreaks();

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    renderBreaks();

    // Barre d'achat fixe
    var stickyBar = $('[data-sticky-atc]', section);
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(addBtn);
      $('[data-sticky-add]', stickyBar).addEventListener('click', function () {
        if (form) addToCart(form, this);
      });
    }

    // Date de livraison estimée (jours ouvrés)
    var del = $('[data-delivery]', section);
    if (del) {
      var min = parseInt(del.getAttribute('data-min'), 10) || 3;
      var max = parseInt(del.getAttribute('data-max'), 10) || 7;
      var cutoff = parseInt(del.getAttribute('data-cutoff'), 10) || 0;
      var now = new Date();
      var startShift = cutoff > 0 && now.getHours() >= cutoff ? 1 : 0;
      function addBusinessDays(date, n) {
        var d = new Date(date);
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
        return d;
      }
      var fmt = { weekday: 'short', day: 'numeric', month: 'long' };
      var loc = (T.locale || 'fr-FR');
      var a, b;
      try {
        a = addBusinessDays(now, min + startShift).toLocaleDateString(loc, fmt);
        b = addBusinessDays(now, max + startShift).toLocaleDateString(loc, fmt);
      } catch (err) {
        a = addBusinessDays(now, min + startShift).toLocaleDateString(undefined, fmt);
        b = addBusinessDays(now, max + startShift).toLocaleDateString(undefined, fmt);
      }
      $('[data-delivery-range]', del).textContent = a + ' – ' + b;
      var cut = $('[data-delivery-cutoff]', del);
      if (cut && cutoff > 0 && now.getHours() < cutoff && now.getDay() !== 0 && now.getDay() !== 6) {
        var timerEl = $('[data-delivery-timer]', del);
        var tickCut = function () {
          var end = new Date(); end.setHours(cutoff, 0, 0, 0);
          var diff = Math.floor((end - new Date()) / 1000);
          if (diff <= 0) { cut.hidden = true; return; }
          timerEl.textContent = Math.floor(diff / 3600) + 'h ' + pad(Math.floor(diff % 3600 / 60)) + 'min';
          cut.hidden = false;
        };
        tickCut();
        setInterval(tickCut, 30000);
      }
    }
  }

  /* ---------- Recommandations produits ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      observeAnimations(el);
    });
  });

  /* ---------- Tri de collection ---------- */
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Pop-up newsletter ---------- */
  var popup = $('[data-popup]');
  function closePopup() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    document.body.classList.remove('is-locked');
    try { localStorage.setItem('popupUntil', String(Date.now() + (parseInt(popup.getAttribute('data-days'), 10) || 7) * 864e5)); } catch (e) {}
  }
  if (popup) {
    var success = $('[data-popup-success]', popup);
    var showPopup = function () { popup.hidden = false; };
    if (success) { showPopup(); }
    else if (!popup.hasAttribute('data-design-mode')) {
      var until = 0, done = false;
      try { until = parseInt(localStorage.getItem('popupUntil'), 10) || 0; done = localStorage.getItem('popupDone') === '1'; } catch (e) {}
      if (!done && Date.now() > until) {
        setTimeout(showPopup, (parseInt(popup.getAttribute('data-delay'), 10) || 8) * 1000);
      }
    }
    $$('[data-popup-close]', popup).forEach(function (b) { b.addEventListener('click', closePopup); });
    document.addEventListener('shopify:section:select', function (e) { if (popup.closest('.shopify-section') && e.target.contains(popup)) popup.hidden = false; });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(popup)) popup.hidden = true; });
  }

  /* ---------- Copier un code promo ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var code = b.getAttribute('data-copy');
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { toast('✓ ' + code); });
  });

  /* ---------- Animations d'apparition ---------- */
  var io = 'IntersectionObserver' in window && document.body.classList.contains('has-animations')
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -40px 0px' })
    : null;
  function observeAnimations(root) {
    $$('[data-animate]', root).forEach(function (el, i) {
      if (!io) { el.classList.add('is-in'); return; }
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  }
  observeAnimations(document);

  /* ---------- Éditeur de thème : réinitialiser après modification ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    observeAnimations(e.target);
    $$('[data-product-section]', e.target).forEach(initProduct);
  });
})();
